import { StepOfCurrentParser } from 'utils/enums';

export const StepOfParserWithStopping = [
	StepOfCurrentParser.ETL_FILES_PARSING,
	StepOfCurrentParser.ETL_UNDEFINED_DATA,
	StepOfCurrentParser.BILL_CREATE_SINGLE_RECEIPT,
	StepOfCurrentParser.REPORT_CREATE_GENERATE_PDF_SINGLE_RECEIPT,
];
